import React from 'react';

export default class OnOffField extends React.Component {
  static defaultProps = {
    className: 'w-100 form-control form-control-sm',
    onChange: () => {},
    value: null,
    // The words beside the switch; a switch that picks between two modes names them (OfficeOrGroupSelect).
    onLabel: 'On',
    offLabel: 'Off',
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const on = Boolean(this.props.value);
    const toggle = () => this.props.onChange(!this.props.value);
    return (
      <div
        className={`ds-switch${on ? ' on' : ''}`}
        role='switch'
        aria-checked={on}
        tabIndex={0}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        }}
      >
        <span className='ds-switch-track'>
          <span className='ds-switch-knob' />
        </span>
        <span className='ds-switch-label'>{on ? this.props.onLabel : this.props.offLabel}</span>
      </div>
    );
  }
}
